import { render } from "./BlogLayout.vue?vue&type=template&id=2dfd4014"
import script from "./BlogLayout.vue?vue&type=script&lang=js"
export * from "./BlogLayout.vue?vue&type=script&lang=js"
script.render = render

export default script